import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { smallTitle } from '@ifca-root/react-component/src/helpers/Global/ContractGlobalVar';
import { useMediaQuery } from '@ifca-root/react-component/src/helpers/PDFFormatter/mediaSize';
import { onPrintELetter } from '@ifca-root/react-component/src/helpers/PDFFormatter/printPdfFunction';
import ShareIcon from '@material-ui/icons/Share';
import { Pagination } from '@material-ui/lab';
import { ErrorDialog } from 'components/Dialog/ErrorDialog';
import ShareDialog from 'components/Dialog/ShareDialog';
import {
  useGetShareAttachmentMutation,
  useSubmittedByLedgerQuery,
} from 'generated/graphql';
import * as htmlToImage from 'html-to-image';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import '../../../assets/styles/PDFStyle.scss';
import ELetterPreview from '../../ELettering/ELetterTemplate/ELetterPreview';
import {
  CLIENT_CONTRACT,
  DELIVERY_ORDER,
  DETAIL,
  DIRECT_PO,
  GOOD_RETURN_NOTE,
  PROJECT_PURCHASE,
  PURCHASE_ON_BEHALF,
  PURCHASE_ORDER,
  PURCHASE_REQ,
} from '../ProjectPurchaseRoutes';

import {
  CLIENT_CONTRACT as POB_CLIENT_CONTRACT,
  DELIVERY_ORDER as POB_DELIVERY_ORDER,
  DETAIL as POB_DETAIL,
  DIRECT_PO as POB_DIRECT_PO,
  GOOD_RETURN_NOTE as POB_GOOD_RETURN_NOTE,
  PROJECT_PURCHASE as POB_PROJECT_PURCHASE,
  PURCHASE_ON_BEHALF as POB_PURCHASE_ON_BEHALF,
  PURCHASE_ORDER as POB_PURCHASE_ORDER,
  PURCHASE_REQ as POB_PURCHASE_REQ,
} from '../../POBProjectPurchaseModule/ProjectPurchaseRoutes';

import { usePurchaseQueries } from '../Query/usePurchaseQueries';
import { useGetCurrencySetupQuery } from '@contract-root/admin-react/src/generated/graphql';

export const PurchasePreviewDetailPDF = (props: any) => {
  const { accountType, docType } = props;
  let history = useHistory();
  let location = useLocation();
  const companyID = localStorage.getItem('companyID');
  const user = JSON.parse(localStorage.getItem('loggedInUser'));

  const projectPurchasePOBSubscriber = JSON.parse(
    localStorage.getItem('projectPurchasePOBSubscriber'),
  );

  const locationState = location?.state || null;
  const { id, pId, rfqID, dpoID, dId, gId }: any = useParams();

  const [errMessage, setErrMessage] = useState(null);
  const [errDialog, setErrDialog] = useState(false);

  const [width] = useMediaQuery();

  let fontSize;
  if (width < 769) {
    fontSize = 7;
  } else {
    fontSize = 10;
  }

  let fontStyle = { fontSize: fontSize, textAlign: 'center' };
  let documentName;
  let title;
  let smTitle;
  let creditorOrDebtor;
  let name;
  let itemName;
  let hasItem: boolean;
  let docRefTable: string = 'c_purchaseReq';
  let returnPath: string;
  let transactionID: string;

  smTitle = smallTitle.SUPPLIER_ACCOUNTS;
  creditorOrDebtor = 'CreditorAccount';
  name = 'CompanyName';

  const isPurchaseOrderType =
    docType === 'purchase-order' ||
    docType === 'po-on-behalf' ||
    docType === 'direct-po' ||
    docType === 'direct-po-on-behalf';

  switch (docType) {
    case 'purchase-requisition':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseReq'
        : 'c_purchaseReq';
      documentName = 'Purchase Requisition';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${PURCHASE_REQ}/${DETAIL}/${pId}`;
      transactionID = pId;
      title = 'PURCHASE REQUISITION';
      itemName = 'prItem';
      hasItem = true;
      break;
    case 'pr-on-behalf':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseReq'
        : 'c_purchaseReq';
      documentName = 'Purchase Requisition';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${PURCHASE_REQ}/${PURCHASE_ON_BEHALF}/${DETAIL}/${pId}`;
      transactionID = pId;
      title = 'PURCHASE REQUISITION';
      itemName = 'prItem';
      hasItem = true;
      break;
    case 'rfq':
      docRefTable = projectPurchasePOBSubscriber ? 'c_projectPOBrfq' : 'c_rfq';
      documentName = 'Request for Quotation';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/rfq/${rfqID}/view`;
      transactionID = rfqID;
      title = 'RFQ';
      itemName = 'rfqItem';
      hasItem = true;
      break;
    case 'purchase-order':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseOrder'
        : 'c_purchaseOrder';
      documentName = 'Purchase Order';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${PURCHASE_ORDER}/${DETAIL}/${pId}`;
      transactionID = pId;
      title = 'PURCHASE ORDER';
      itemName = 'poItem';
      hasItem = true;
      break;
    case 'po-on-behalf':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseOrder'
        : 'c_purchaseOrder';
      documentName = 'Purchase Order';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${PURCHASE_ORDER}/${PURCHASE_ON_BEHALF}/${DETAIL}/${pId}`;
      transactionID = pId;
      title = 'PURCHASE ORDER';
      itemName = 'poItem';
      hasItem = true;
      break;
    case 'direct-po':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseOrder'
        : 'c_purchaseOrder';
      documentName = 'Purchase Order';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${DIRECT_PO}/${DETAIL}/${dpoID}`;
      transactionID = dpoID;
      title = 'DIRECT PO';
      itemName = 'poItem';
      hasItem = true;
      break;
    case 'direct-po-on-behalf':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseOrder'
        : 'c_purchaseOrder';
      documentName = 'Purchase Order';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${DIRECT_PO}/${PURCHASE_ON_BEHALF}/${DETAIL}/${dpoID}`;
      transactionID = dpoID;
      title = 'DIRECT PO';
      itemName = 'poItem';
      hasItem = true;
      break;
    case 'delivery-order':
      docRefTable = projectPurchasePOBSubscriber ? 'c_projectPOBdo' : 'c_do';
      documentName = 'Good Receive Note';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${DELIVERY_ORDER}/${DETAIL}/${dId}`;
      transactionID = dId;
      title = 'GOOD RECEIVE NOTE';
      itemName = 'doItem';
      hasItem = true;
      break;
    case 'good-return-note':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBgrtn'
        : 'c_grtn';
      documentName = 'Good Return Note';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${GOOD_RETURN_NOTE}/${DETAIL}/${gId}`;
      transactionID = gId;
      title = 'GOOD RETURN NOTE';
      itemName = 'goodReturnNoteItem';
      hasItem = true;
      break;
  }

  const {
    loading: subByLoading,
    data: { submittedByLedger } = { submittedByLedger: '' },
  } = useSubmittedByLedgerQuery({
    fetchPolicy: 'network-only',
    variables: { docRefTable, docRefID: transactionID },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const {
    loading: currencySetupLoading,
    error: currencySetupError,
    data: { getCurrencySetup } = { getCurrencySetup: [] },
  } = useGetCurrencySetupQuery({
    fetchPolicy: 'network-only',
    variables: { id: id },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrDialog(true);
      setErrMessage(error);
    },
  });

  const {
    loading,
    listData,
    primaryKey,
    watermarkData,
    templateBody,
    letterTemplateLoading,
    approvalLogData,
    approvalLogLoading,
  } = usePurchaseQueries({
    accountType,
    docType,
    companyID,
    transactionID: transactionID,
    setErrMessage,
    setErrDialog,
    projectPurchasePOBSubscriber,
  });

  const previewDetail: any =
    listData?.length > 0 && getCurrencySetup?.length > 0
      ? {
          ...listData?.filter(v => v?.[primaryKey] === transactionID)?.[0],
          ['currencyByDoc']: getCurrencySetup?.find(
            e =>
              e?.ID ===
              listData?.filter(v => v?.[primaryKey] === transactionID)?.[0]
                ?.currencyID,
          ),
        }
      : listData?.filter(v => v?.[primaryKey] === transactionID)?.[0];

  // ========== Page definition ==========
  const [page, setCurrentPage] = useState<number>(0);

  // ========== Remap Data for item list ==========
  const [remapData, setRemapData] = useState(null);
  const [poWithRepeatedHeaders, setPoWithRepeatedHeaders] = useState(null);

  const separateThreshold = input => {
    if (!!hasItem && input?.[itemName]) {
      // For purchase orders: 10 items per page, for others: 500
      const itemsPerPage = isPurchaseOrderType ? 10 : 500;

      const items = input[itemName];
      const pages = [];

      for (let i = 0; i < items.length; i += itemsPerPage) {
        const pageItems = items.slice(i, i + itemsPerPage);
        pages.push({
          ...input,
          [itemName]: pageItems.map((item, index) => ({
            ...item,
            index: i + index + 1,
            pageIndex: index + 1, // Local index within page (1-10)
          })),
          pageNumber: pages.length + 1,
          totalPages: Math.ceil(items.length / itemsPerPage),
        });
      }

      setRemapData(pages.length > 0 ? pages : [{ ...input, [itemName]: [] }]);

      if (isPurchaseOrderType) {
        const poPages = [];
        for (let i = 0; i < items.length; i += itemsPerPage) {
          const pageItems = items.slice(i, i + itemsPerPage);
          const currentPage = poPages.length + 1;
          const totalPages = Math.ceil(items.length / itemsPerPage);
          const isLastPage = currentPage === totalPages;

          console.log(
            `PO Page ${currentPage} - Global indexes:`,
            pageItems.map((item, idx) => i + idx + 1),
          );

          poPages.push({
            ...input,
            docNo: input.docNo,
            docDate: input.docDate,
            supplierName: input.supplierName,
            supplierAddress: input.supplierAddress,
            contactNo: input.contactNo,
            contractTitle: input.contractTitle,
            deliveryDate: input.deliveryDate,
            preparedBy: input.preparedBy,
            requestedBy: input.requestedBy,
            paymentTerm: input.paymentTerm,
            companyName: input.companyName,
            companyRegNo: input.companyRegNo,
            companyGstNo: input.companyGstNo,
            companySstNo: input.companySstNo,
            companyAddress: input.companyAddress,
            companyContactNo: input.companyContactNo,
            companyCurrencyCode:
              input.companyCurrencyCode || user?.companyCurrencyCode,
            sumTaxAmt: input.sumTaxAmt,
            sumBaseAmt: input.sumBaseAmt,
            sumTotalAmt: input.sumTotalAmt,
            totalAmtInWords: input.totalAmtInWords,
            specialInstruction: input.specialInstruction,
            termsConditions: input.termsConditions,
            deliveryLocation: input.deliveryLocation,
            contactPerson: input.contactPerson,
            remarks: input.remarks,
            currency: input.currency || user?.companyCurrencyCode,

            // Page specific data
            [itemName]: pageItems.map((item, index) => ({
              ...item,
              index: i + index + 1,
              pageIndex: index + 1,
            })),
            PageNo: currentPage,
            TotalPage: totalPages,
            pageNumber: currentPage,
            totalPages: totalPages,

            hideFooterOnThisPage: !isLastPage, // TRUE for non-last pages
            isLastPage: isLastPage,
          });
        }
        setPoWithRepeatedHeaders(poPages.length > 0 ? poPages : [input]);
      }
    } else {
      setRemapData([{ ...input }]);
      if (isPurchaseOrderType) {
        setPoWithRepeatedHeaders([input]);
      }
    }
  };

  useEffect(() => {
    if (!!previewDetail && remapData === null) {
      separateThreshold(previewDetail);
    }
  }, [previewDetail]);

  /* ========================================= */
  /* DOCS THAT IS SAVED AS PDF WHICH IS HIDDEN */
  /* ========================================= */
  const pdfToPrint = () => {
    return (
      <div style={{ position: 'fixed', left: `-1000px` }}>
        <div id={'pdf-data-print-wrapper'}>
          {isPurchaseOrderType && poWithRepeatedHeaders ? (
            poWithRepeatedHeaders.map((pageData, index) => (
              <React.Fragment key={index}>
                <ELetterPreview
                  fontStyle={fontStyle}
                  title={title}
                  previewDetail={pageData}
                  allpreviewDetail={previewDetail}
                  accountType={accountType}
                  docType={docType}
                  itemName={itemName}
                  creditorOrDebtor={creditorOrDebtor}
                  submittedByLedger={submittedByLedger}
                  remapData={[pageData]}
                  page={0}
                  pageLength={poWithRepeatedHeaders.length}
                  hasItem={hasItem}
                  currencyCode={
                    pageData.companyCurrencyCode || user?.companyCurrencyCode
                  }
                  htmlTemplate={templateBody}
                  isPOWithRepeatedHeaders={true}
                  pageNumber={pageData.pageNumber}
                  totalPages={pageData.totalPages}
                  approvalLog={approvalLogData}
                  watermarkData={watermarkData}
                />
                {index < poWithRepeatedHeaders.length - 1 && (
                  <div
                    className="page-break"
                    style={{
                      pageBreakAfter: 'always',
                      breakAfter: 'page',
                    }}
                  />
                )}
              </React.Fragment>
            ))
          ) : !!hasItem ? (
            previewDetail &&
            remapData &&
            remapData?.map((v, index) => {
              return (
                <React.Fragment key={index}>
                  <ELetterPreview
                    fontStyle={fontStyle}
                    title={title}
                    previewDetail={previewDetail}
                    allpreviewDetail={previewDetail}
                    accountType={accountType}
                    docType={docType}
                    itemName={itemName}
                    creditorOrDebtor={creditorOrDebtor}
                    submittedByLedger={submittedByLedger}
                    remapData={remapData}
                    page={index}
                    pageLength={remapData?.length}
                    hasItem={hasItem}
                    currencyCode={user?.companyCurrencyCode}
                    htmlTemplate={templateBody}
                    approvalLog={approvalLogData}
                    watermarkData={watermarkData}
                  />
                  {index < remapData.length - 1 && (
                    <div
                      className="page-break"
                      style={{
                        pageBreakAfter: 'always',
                        breakAfter: 'page',
                      }}
                    />
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <ELetterPreview
              fontStyle={fontStyle}
              title={title}
              previewDetail={previewDetail}
              allpreviewDetail={previewDetail}
              accountType={accountType}
              docType={docType}
              itemName={itemName}
              creditorOrDebtor={creditorOrDebtor}
              submittedByLedger={submittedByLedger}
              remapData={remapData}
              page={page}
              pageLength={1}
              hasItem={hasItem}
              currencyCode={user?.companyCurrencyCode}
              htmlTemplate={templateBody}
              approvalLog={approvalLogData}
              watermarkData={watermarkData}
            />
          )}
        </div>
      </div>
    );
  };

  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [openSendEmail, setOpenSendEmail] = useState(false);

  const [
    shareAttachments,
    {
      loading: shareAttachmentLoading,
      data: { shareAttachment } = { shareAttachment: {} as any },
    },
  ] = useGetShareAttachmentMutation({
    onCompleted: () => {
      setOpenShareDialog(true);
    },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const onSubmit = blob => {
    // shareAttachments({ variables: { file: blob } });
  };

  // Get current page data for view mode
  const getCurrentPageData = () => {
    if (isPurchaseOrderType && poWithRepeatedHeaders) {
      return poWithRepeatedHeaders[page] || previewDetail;
    }
    return previewDetail;
  };

  return (
    <>
      {loading && <Loading />}
      {subByLoading && <Loading />}
      {currencySetupLoading && <Loading />}
      {letterTemplateLoading && <Loading />}
      {shareAttachmentLoading && <Loading />}
      {approvalLogLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          if (locationState?.backPath) {
            history.push({
              pathname: locationState.backPath,
            });
            return;
          }

          history.push({
            pathname: returnPath,
            state: locationState !== null ? locationState : previewDetail,
          });
        }}
        smTitle={smTitle}
        title={user?.companyName}
        routeSegments={[
          { name: `${smallTitle}` },
          { name: `${documentName}` },
          { name: `${documentName}`, current: true },
        ]}
        // rightRouteSegments={[{ name: `Print`, current: true }]}
      />
      <ContentWrapper footer>
        <div>
          <ELetterPreview
            fontStyle={fontStyle}
            title={title}
            previewDetail={getCurrentPageData()}
            allpreviewDetail={previewDetail}
            accountType={accountType}
            docType={docType}
            itemName={itemName}
            creditorOrDebtor={creditorOrDebtor}
            submittedByLedger={submittedByLedger}
            remapData={isPurchaseOrderType ? poWithRepeatedHeaders : remapData}
            page={page}
            pageLength={
              isPurchaseOrderType
                ? poWithRepeatedHeaders?.length ?? 1
                : remapData?.length ?? 1
            }
            hasItem={hasItem}
            currencyCode={user?.companyCurrencyCode}
            htmlTemplate={templateBody}
            isView={true}
            isPOWithRepeatedHeaders={isPurchaseOrderType}
            pageNumber={
              isPurchaseOrderType && poWithRepeatedHeaders
                ? poWithRepeatedHeaders[page]?.pageNumber
                : page + 1
            }
            totalPages={
              isPurchaseOrderType
                ? poWithRepeatedHeaders?.length ?? 1
                : remapData?.length ?? 1
            }
            approvalLog={approvalLogData}
            watermarkData={watermarkData}
          />
        </div>

        <div className={`pagination-dis-${width < 769 ? 'mobile' : 'desktop'}`}>
          <Pagination
            count={
              isPurchaseOrderType
                ? poWithRepeatedHeaders?.length ?? 1
                : remapData?.length ?? 1
            }
            shape="rounded"
            page={page + 1}
            onChange={(e, page) => {
              setCurrentPage(page - 1);
            }}
          />
        </div>
      </ContentWrapper>

      <div style={{ width: 1980 }}>{pdfToPrint()}</div>

      {ShareDialog({
        shareTitle: `${smallTitle} - ${title}`,
        title: `Share`,
        URL: shareAttachment?.fileURL,
        setSimple: setOpenShareDialog,
        simple: openShareDialog,
        emailShare: openSendEmail,
        setSimpleEmail: setOpenSendEmail,
      })}

      <Footer
        options={[
          {
            name: 'Share',
            onClick: async () => {
              let temp = await document.getElementById(
                'pdf-data-print-wrapper',
              );

              htmlToImage
                .toBlob(temp, { style: { background: '#fff' } })
                .then(value => {
                  onSubmit(value);
                })
                .catch(error => console.error(error, 'Something went wrong'));
            },
            color: 'primary',
            props: { type: 'submit' },
            startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
          },
          {
            name: 'Download',
            color: 'primary',
            onClick: () => {
              onPrintELetter(width, documentName, previewDetail?.docNo);
            },
          },
        ]}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  );
};
